import { useLocation as useReachLocation } from "@reach/router";

export const useLocation = useReachLocation;
